import React from 'react';
import './TrustedBy.css';
import client1 from "../../assets/clients/client1.png";
import client2 from "../../assets/clients/client2.png";
import client3 from "../../assets/clients/client3.png";
import client4 from "../../assets/clients/client4.png";
import client5 from "../../assets/clients/client5.png";
import client6 from "../../assets/clients/client6.png";
import client7 from "../../assets/clients/client7.png";
import client8 from "../../assets/clients/client8.png";
import client9 from "../../assets/clients/client9.png";
import client10 from "../../assets/clients/client10.png";
import client11 from "../../assets/clients/client11.png";
import client12 from "../../assets/clients/client12.png";
import client13 from "../../assets/clients/client13.png";
import client14 from "../../assets/clients/client14.png";
import client15 from "../../assets/clients/client15.png";
import client16 from "../../assets/clients/client16.png";

// ── Data from GSK Geotech company profile ──────────────────────────────────

const STATS = [
  { number: '65+',  label: 'Projects Completed' },
  { number: '$6M+', label: 'Contract Value' },
  { number: '22+',  label: 'Years Experience' },
  { number: '100%', label: 'Completion Rate' },
];

const CLIENTS = [
  { name: 'MK Tunnel Pte Ltd',                  icon: client5 },
  { name: 'Megastones Holdings Pte Ltd',        icon: client6 },
  { name: 'Takenaka Corporation',                icon: client7 },
  { name: 'GeoMotion Singapore',              icon: client8 },
  { name: 'Tae Hwa Geological Engineering',   icon: client9 },
  { name: 'Sindong Geological Engineering',   icon: client10 },
  { name: 'Jae Hwan Construction Pte Ltd',      icon: client11 },
  { name: 'Be Time Engineering Pte Ltd',        icon: client12 },
  { name: 'Neo Arch Engineering Pte Ltd',           icon: client13 },
  { name: 'King View Engineering Pte Ltd',          icon: client14 },
  { name: 'ASK M&E Pte Ltd',                        icon: client15 },
  { name: 'Ryobi Geotechnic SGS',                  icon: client16 },
];

const CERTS = [
  'SBI (I&M)/SI',
  'SB (GS)',
  'CR15',
  'CR12',
  'ISO 45001:2018',
  'ISO 9001:2015',
  'BIZ SAFE STAR',
  'SAC Accreditation'
];

const BAND_VALUES = ['Safety First', 'Quality & Production', 'Sequential Work'];

// ── Component ──────────────────────────────────────────────────────────────

const TrustedBy = () => {
  return (
    <section className="trusted-section" id="trusted">
      <div className="trusted-container">

        {/* ── Header ── */}
        <div className="trusted-header">
          <div className="trusted-eyebrow">
            <span className="trusted-eyebrow-line" />
            Trusted By
            <span className="trusted-eyebrow-line" />
          </div>
          <h2 className="trusted-title">
            Clients Who Rely On<br />
            <span>GSK Geotech</span>
          </h2>
          <p className="trusted-subtitle">
            Proud to serve government agencies, leading private developers, and
            specialist engineering firms across Singapore.
          </p>
        </div>

        {/* ── Stats Strip ── */}
        <div className="trusted-stats">
          {STATS.map((s) => (
            <div className="stat-item" key={s.label}>
              <span className="stat-number">{s.number}</span>
              <span className="stat-label">{s.label}</span>
            </div>
          ))}
        </div>

        {/* ── Clients Grid ── */}
        <p className="trusted-clients-label">Our Valued Clients &amp; Partners</p>
        <div className="clients-grid">
          {CLIENTS.map((c) => (
            <div className="client-card" key={c.name}>
              <img src={c.icon} alt={c.name} className="client-icon" />
              <div className="client-name">{c.name}</div>
              <span className="client-tag">{c.tag}</span>
            </div>
          ))}
        </div>

        {/* ── Certifications + Bottom Band ── */}
        <div className="trusted-certs">
          <div className="certs-inner">
            <div className="certs-header">
              <h3 className="certs-title">Certified &amp; <span>Compliant</span></h3>
              <p className="certs-subtitle">
                Industry-recognised certifications ensuring the highest standards
              </p>
            </div>
            <div className="certs-row">
              {CERTS.map((cert) => (
                <div className="cert-badge" key={cert}>
                  <span className="cert-dot" />
                  <span className="cert-name">{cert}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="trusted-bottom-band">
            <p className="band-text">
              <strong>"Your trusted partner in Geotechnical Engineering"</strong>
              &nbsp;— We strive hard to ensure the work is executed safely and
              with high quality.
            </p>
            <div className="band-values">
              {BAND_VALUES.map((v) => (
                <span className="band-value" key={v}>{v}</span>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TrustedBy;